export const LIFE_AREA_ARCHIVED_SECTION_ID = 'life-area-archived';
